<ul class="MyMoeinList">

  <li *ngFor="let item of DataList_History">
      <a>
        <i class="fa fa-user"></i>
        &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <b>{{item.fullname}}</b>
      </a>
      <div class="subMoeinDiv">
          <img src="{{BaseUrl}}{{item.imageUser}}" />
          <div class="subMoeinDivDetail">
              <p> Full Name : {{item.fullname}}</p>
              <h6>{{item.btnDsc}}</h6>
          </div>
          <div style="clear:both"></div>
          <p class="subMoeinDsc"> Description : {{item.dsc}} </p>
          <p class="subMoeinFooter"> Sent At : {{item.submitDate}}</p>

      </div>
      <app-FlowchartHistory [DataList_History]="item.detail"></app-FlowchartHistory>
  </li>
</ul>
